/* Before/after comparison slider. */
document.querySelectorAll('[data-berara-compare]').forEach((slider) => {
  const input = slider.querySelector('input[type="range"]');
  if (!input) return;

  const update = () => {
    slider.style.setProperty('--compare-position', input.value + '%');
  };

  input.addEventListener('input', update, { passive: true });
  update();
});

/* Horizon swaps the purchase column in place on a variant change, so the
   sections below it have to follow that event rather than the page load. */
// The variant picker dispatches on itself and the event does not bubble, so
// the listener has to run in the capture phase to see it from the document.
document.addEventListener(
  'shopify:product:select',
  (event) => {
    const selected = event.selectedOptions || (event.detail && event.detail.selectedOptions);
    if (!Array.isArray(selected) || !selected.length) return;

    const sizeCell = document.querySelector('[data-berara-live-size]');
    const section = document.querySelector('[data-berara-size-options]');
    if (sizeCell && section) {
      const names = section.dataset.beraraSizeOptions
        .split(',')
        .map((name) => name.trim().toLowerCase())
        .filter(Boolean);
      const match = selected.find((option) => names.includes(String(option.name).trim().toLowerCase()));
      if (match) sizeCell.textContent = match.value;
    }

    const used = document.querySelector('[data-berara-used]');
    if (used) {
      // Shopify names a variant by joining its option values, so the line reads
      // the same as the variant the customer just picked.
      const variantTitle = selected.map((option) => option.value).join(' / ');
      const parts = [used.dataset.usedPrefix, used.dataset.productTitle].filter(Boolean);
      used.textContent = parts.join(' ') + (variantTitle ? ' \u00b7 ' + variantTitle : '');
    }
  },
  true
);
